/**
 * ApplyEntryEffect — wraps a slide's children with the CSS class that
 * triggers the chosen entry animation. The class is sourced from
 * `entryRegistry`.
 *
 * - Unknown / missing codes render children as-is (no wrapper).
 * - Animation only fires on mount; remounting (e.g. via a `playbackKey`
 *   key on the parent) is the way to replay the entry.
 */
import type { ReactNode } from 'react';
import { resolveEntryClass } from './entryRegistry';

export interface ApplyEntryEffectProps {
  code: string | undefined | null;
  children: ReactNode;
}

export function ApplyEntryEffect({ code, children }: ApplyEntryEffectProps) {
  const className = resolveEntryClass(code);
  if (!className) return <>{children}</>;
  return <div className={className}>{children}</div>;
}
